import React, { ReactElement } from 'react';
import './MoreInfo.scss';

interface MoreInfoProps {
    tags: string[];
    synopsis: string;
}

const MoreInfo = ({ tags = [''], synopsis }: MoreInfoProps): ReactElement => {
    return (
        <div className='series-more-info-container'>
            {/*<div className='series-more-info-tags-container'>*/}
            {/*    <p className='series-more-info-tags-title'>Content Warning</p>*/}

            {/*    <div className='series-more-info-tags-wrapper'>*/}
            {/*        {tags.map((tag) => {*/}
            {/*            return <span key={tag} className='series-more-info-tags-text'>{tag}</span>;*/}
            {/*        })}*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className='series-more-info-description-wrapper'>
                <span className='series-more-info-description-title'>Synopsis</span>
                <p className='series-more-info-description-text' dangerouslySetInnerHTML={{__html: synopsis}}>
                    {/*{synopsis}*/}
                </p>
            </div>
        </div>
    );
};

export default MoreInfo;